import { render } from "./Toolbar.vue?vue&type=template&id=c5b123b6&scoped=true"
import script from "./Toolbar.vue?vue&type=script&lang=js"
export * from "./Toolbar.vue?vue&type=script&lang=js"

import "./Toolbar.vue?vue&type=style&index=0&id=c5b123b6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c5b123b6"

export default script